import React from "react";
import "./Hero.css";

const heroImage = "/media/images/large-0196d8cf-a6d3-7074-95c3-abf872693b14.jpeg";

const Hero = () => {
  return (
    <div className="hero" style={{ backgroundImage: `url(${heroImage})` }}>
      <div className="overlay">
        <h1>10 Roosevelt Rd</h1>
        <p>Maplewood, NJ 07040</p>
        <p>Luxury Townhouse</p>
      </div>
    </div>
  );
};

export default Hero;
